var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIc16SocialTwitter = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentcolor",
  d: "M5.403 13.378c5.283 0 8.172-4.377 8.172-8.173 0-.124-.002-.248-.008-.37A5.841 5.841 0 0 0 15 3.346a5.727 5.727 0 0 1-1.65.452 2.883 2.883 0 0 0 1.264-1.589c-.564.335-1.181.57-1.824.698a2.873 2.873 0 0 0-4.895 2.62 8.156 8.156 0 0 1-5.92-3.002 2.87 2.87 0 0 0 .89 3.835A2.85 2.85 0 0 1 1.562 6v.037c0 1.39.99 2.552 2.304 2.816a2.876 2.876 0 0 1-1.298.049 2.875 2.875 0 0 0 2.684 1.995A5.763 5.763 0 0 1 1 12.088a8.13 8.13 0 0 0 4.403 1.29"
})));
export default SvgIc16SocialTwitter;